import TableDataColumn1 from "./TableDataColumn1";
import TableDataColumn2 from "./TableDataColumn2";
import TableDataColumn3 from "./TableDataColumn3";

export default function LabelYourInputData() {

  return(
    <div className="flex">
      <div className="bg-promLightBlue1">
        <div className="ml-2">
          <div className="text-24px">
            2 - Label your input data
          </div>
          <div>
            Label(map) your fields to make sure the timePhasing service <br/> 
            understands what is your Start Date, Finish Date and <br/>
            Value(quantity) to be time-phased
          </div>
        </div>
        
        <div className="bg-promLightBlue3 pb-4">
          <table className="mt-4 font-inter">
            <tr className="bg-promLightBlue2">
              <td className="text-right pr-2">Property</td>
              <td>Your field</td>
              <td className="text-left pl-2">Description</td>
            </tr>
            <tr>
              <TableDataColumn1 description={"Start Date"} />
              <TableDataColumn2 description={"Start"} />
              <TableDataColumn3 description={"Your field [Start] is used as [Start Date]"} />
            </tr>
            <tr>
              <TableDataColumn1 className="pl-2" description={"Finish Date"} />
              <TableDataColumn2 description={"Finish"} />
              <TableDataColumn3 description={"Your field [Finish] is used as [Finish Date]"} />
            </tr>
            <tr>
              <TableDataColumn1 description={"Value"} />
              <TableDataColumn2 description={"Cost"} />
              <TableDataColumn3 description={"Your field [Cost] is used as [Value]"} />
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
}